import { siteTexts } from "../../../shared/i18n/siteTexts";
import type {
  ChallengeCategoryCode,
  ChallengeCategoryGender,
  ChallengeHistoryItem,
  ChallengeType,
} from "../types/challengeAdmin";

export function challengeTypeLabel(type: ChallengeType) {
  if (type === "challenge") return siteTexts.challenges.modes.challenge.title;
  if (type === "super8") return siteTexts.challenges.modes.super8.title;
  if (type === "poco") return siteTexts.challenges.modes.poco.title;
  return siteTexts.challenges.modes.tournament.title;
}

export function categoryLabel(category: ChallengeCategoryCode) {
  if (category === "7a") return siteTexts.common.category.c7a;
  if (category === "6a") return siteTexts.common.category.c6a;
  if (category === "5a") return siteTexts.common.category.c5a;
  if (category === "4a") return siteTexts.common.category.c4a;
  if (category === "3a") return siteTexts.common.category.c3a;
  if (category === "2a") return siteTexts.common.category.c2a;
  if (category === "open") return siteTexts.common.category.open;
  if (category === "free") return siteTexts.common.category.free;
  return category;
}

export function categoryGenderLabel(gender: ChallengeCategoryGender) {
  if (gender === "mixed") return siteTexts.common.challengeGender.mixed;
  if (gender === "open") return siteTexts.common.challengeGender.open;
  if (gender === "male") return siteTexts.common.challengeGender.male;
  return siteTexts.common.challengeGender.female;
}

export function challengeCategorySummary(item: ChallengeHistoryItem) {
  const gender = item.categoryGender;
  const category = item.category;
  const categoryMale = item.categoryMale;
  const categoryFemale = item.categoryFemale;

  if (gender === "mixed" || gender === "open") {
    if (categoryMale && categoryFemale) {
      if (categoryMale === categoryFemale) {
        return `${categoryGenderLabel(gender)} ${categoryLabel(categoryMale)}`;
      }
      return `${categoryGenderLabel(gender)} ${categoryLabel(categoryMale)} / ${categoryLabel(categoryFemale)}`;
    }
    if (category) {
      return `${categoryGenderLabel(gender)} ${categoryLabel(category)}`;
    }
    return `${categoryGenderLabel(gender)}`;
  }

  if (gender === "male" || gender === "female") {
    const baseCategory =
      category || (gender === "male" ? categoryMale : categoryFemale);
    if (baseCategory) {
      return `${categoryGenderLabel(gender)} ${categoryLabel(baseCategory)}`;
    }
    return `${categoryGenderLabel(gender)}`;
  }

  if (category) return `${categoryLabel(category)}`;
  if (categoryMale && categoryFemale) {
    if (categoryMale === categoryFemale) {
      return `${categoryLabel(categoryMale)}`;
    }
    return `${categoryLabel(categoryMale)} / ${categoryLabel(categoryFemale)}`;
  }
  if (categoryMale) return `${categoryLabel(categoryMale)}`;
  if (categoryFemale) return `${categoryLabel(categoryFemale)}`;
  return `${siteTexts.common.category.notInformed}`;
}
